import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FloatingTooltip } from '../../Floating'
import {
  ICON_HEIGHT_20,
  ICON_HEIGHT_24,
  IconSpinnerOverlay,
  IconWithTooltip,
} from '../../Icon'

import * as styles from './DocFlowFileOverlay.module.css'

import SelectedIcon from '../../../icons/unique/success.svg'

function DocFlowFileOverlay({
  className = styles.DocFlowFileOverlay,
  disabled,
  done,
  isActive,
  process,
}) {
  const { t } = useTranslation()

  return (
    <div
      className={classNames(className, {
        [styles.active]: isActive,
        [styles.disabled]: disabled,
      })}
    >
      <div className={styles.icon}>
        {done ? (
          <IconWithTooltip
            Icon={SelectedIcon}
            svgSize={ICON_HEIGHT_20}
            tooltip={t('DocumentStapling.UploadedFileStatusDoneTooltipKey')}
          />
        ) : null}

        {process ? (
          <FloatingTooltip
            content={t('DocumentStapling.UploadedFileStatusProcessTooltipKey')}
          >
            <IconSpinnerOverlay size={ICON_HEIGHT_24} />
          </FloatingTooltip>
        ) : null}
      </div>
    </div>
  )
}

export default DocFlowFileOverlay
